//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Multiselect from '../Multiselect.vue';
export default {
    name: 'AccordionConstructor',
    components: {
        Multiselect,
    },
    props: ['value', 'options', 'placeholder', 'disabled'],
    data() {
        return {};
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
    methods: {
        changeVal(event) {
            if (!event) return;
            this.$emit('change-input', event.value);
        },
    },
};
